import React from 'react';
import Image from 'next/image';
import Button from '../Button/Button';
import Link from 'next/link';
import { stringToSlug } from 'functions/slug';
import { useRouter } from 'next/router';

interface StoreHeaderProps {
    storeName: string;
    storeImage: string;
    country: string;
}

const StoreHeader: React.FC<StoreHeaderProps> = ({ storeName, storeImage, country }) => {
    const router = useRouter();

    const bookingUrl = router.locale === 'ca'
        ? `/ca/book-an-eye-exam?store=${stringToSlug(storeName)}`
        : `/au/book-an-optometrist?store=${stringToSlug(storeName)}`;
    const isFitzroy = storeName.toLowerCase().includes('fitzroy');
    return (
        <div className="relative h-[450px] md:h-[450px] 2xl:h-[65vh] w-full">
            {/* Background Image */}
            {isFitzroy && (
                <div className="absolute top-0 left-0 md:w-[637px] md:h-[216px] w-[454px] h-[154px] z-10">
                    <Image
                        objectFit="contain"
                        fill
                        quality={98}
                        src="/images/fitzroy_move_bigger.png"
                        alt="Fitzroy's Moving Announcement"
                        className="w-full h-full"
                    />
                </div>
            )}
            <div className="relative w-full h-full">
                <Image
                    src={storeImage}
                    alt={`${storeName} store`}
                    layout="fill"
                    objectFit="cover"
                    priority
                />
                {/* Overlay gradient */}
                <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black/50" />
            </div>

            {/* Content */}
            <div className="absolute bottom-0 w-full">
                <div className="mx-auto max-w-[1224px] py-8 px-4 text-center md:text-left">
                    <h1 className="text-4xl md:text-6xl font-bold mb-6 text-white">{storeName}</h1>
                    <div className="flex justify-center md:justify-start">
                        <Link href={bookingUrl}>
                            <Button
                                className="bg-brand-orange hover:bg-brand-orange/90 text-white px-6 py-3 rounded-full"
                                type="button"
                                variant="default"
                            >
                                Book Now
                            </Button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StoreHeader; 